// Utils and Service
import { getErrorMessage, isCanceledError } from '../utils/helpers'

// eslint-disable-next-line import/no-cycle
import axios from './instance'

/**
 * Fetches the global feature-flag settings.
 * @param {func} setLoading
 * @param {func} setError
 * @param {AbortSignal} signal - cancels the request when a newer one supersedes it
 */
export const getGlobalSettings = async (
  setLoading = () => {},
  setError = () => {},
  signal = undefined,
) => {
  setLoading(true)

  try {
    const data = await axios.get('/global-settings/', { signal })
    setLoading(false)
    return data
  } catch (err) {
    // Superseded by a newer request; leave loading state for the in-flight one.
    if (isCanceledError(err)) return null

    setError(getErrorMessage(err))
    setLoading(false)
    return null
  }
}
